import { t } from "@/i18n-js/instance";
import { PriceBadge } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/shared/PriceBadge";
import { previewPriceProperties } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/shared/PriceBadge/constants";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const TotalDueToday = () => {
  const { previewMutation } = usePaywallCheckoutContext();
  const preview = previewMutation.data;
  const shouldShowPreviewBadge = preview;

  return (
    <div className="flex flex-row items-baseline gap-x-2">
      <Typography.LabelMd weight="semibold">
        {t("paywall_checkout.amount_due")}
      </Typography.LabelMd>
      {shouldShowPreviewBadge && (
        <PriceBadge preview={preview} properties={previewPriceProperties} />
      )}
    </div>
  );
};
